module.exports = __webpack_public_path__ + "assets/d7a0373f89f0e214110d885f59ff06e4-DSC_0791.jpg";